<template>
  <div class="container-fluid">
    <table class="xz-table">
      <thead>
      <tr>
        <th class="bold">Betalingsmiddel</th>
        <th class="bold">Antall</th>
        <th class="bold"></th>
        <th class="bold">Beløp</th>
      </tr>
      </thead>
      <tbody>

      <tr>
        <td colSpan="4"><b>Kontant</b></td>
      </tr>
      <tr>
        <td>Total kontant</td>
        <td>{{cashTotalCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalCashPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td colSpan="4"><b>Kredittkort</b></td>
      </tr>
      <tr>
        <td>Total kredittkort</td>
        <td>{{cardTotalCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalCardPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td colSpan="4"><b>BankAxept</b></td>
      </tr>
      <tr>
        <td>Total BankAxept</td>
        <td>{{bankAxeptTotalCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalBankAxeptPaymentsTotalAmount) }}</td>
      </tr>

      <tr v-if="loyaltyPointsTotalCount > 0 || totalLoyaltyPointsPaymentsTotalAmount > 0">
        <td colSpan="4"><b>Bonuspoeng</b></td>
      </tr>
      <tr v-if="loyaltyPointsTotalCount > 0 || totalLoyaltyPointsPaymentsTotalAmount > 0">
        <td>Total bonuspoeng</td>
        <td>{{loyaltyPointsTotalCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalLoyaltyPointsPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td class="bold">Total salg</td>
        <td class="bold">{{totalPaymentCount}}</td>
        <td></td>
        <td class="bold">{{ displayTwoDecimals(totalPayment) }}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
  import TurnoverReportUtil from "@/util/TurnoverReportUtil";
  import MathUtil from "@/util/MathUtil";

  export default {
    props: {
      zReports: Array,
      vat: Object
    },
    computed: {

      cardTotalCount() {
        return TurnoverReportUtil.getCardTotalCount(this.zReports);
      },
      totalCardPaymentsTotalAmount() {
        var cardPaymentsTotalAmount = 0;
        for (var i = 0; i < this.zReports.length; i++) {
          var zReport = this.zReports[i].cagistahospitality;
          let cardDineInPaymentsTotalAmount = zReport.cardDineInPaymentsTotalAmount ? zReport.cardDineInPaymentsTotalAmount : 0;
          
          // Include legacy Vipps payment amounts as card payments
          let vippsPickupAmount = zReport.vippsPickupPaymentsTotalAmount || 0;
          let vippsDineInAmount = zReport.vippsDineInPaymentsTotalAmount || 0;
          let vippsDeliveryAmount = zReport.vippsDeliveryPaymentsTotalAmount || 0;
          let vippsDeliveryServiceAmount = zReport.vippsDeliveryServicePaymentsTotalAmount || 0;
          
          cardPaymentsTotalAmount = cardPaymentsTotalAmount + zReport.cardPickupPaymentsTotalAmount + cardDineInPaymentsTotalAmount + zReport.cardDeliveryPaymentsTotalAmount
            + vippsPickupAmount + vippsDineInAmount + vippsDeliveryAmount + vippsDeliveryServiceAmount;
        }
        return cardPaymentsTotalAmount;
      },

      cashTotalCount() {
        return TurnoverReportUtil.getCashTotalCount(this.zReports);
      },
      totalCashPaymentsTotalAmount() {
        var cashPaymentsTotalAmount = 0;
        for (var i = 0; i < this.zReports.length; i++) {
          var zReport = this.zReports[i].cagistahospitality;
          let cashPickupPaymentsTotalAmountTmp = zReport.cashPickupPaymentsTotalAmount ? zReport.cashPickupPaymentsTotalAmount : 0;
          let cashDineInPaymentsTotalAmountTmp = zReport.cashDineInPaymentsTotalAmount ? zReport.cashDineInPaymentsTotalAmount : 0;
          let cashDeliveryPaymentsTotalAmountTmp = zReport.cashDeliveryPaymentsTotalAmount ? zReport.cashDeliveryPaymentsTotalAmount : 0;
          cashPaymentsTotalAmount = cashPaymentsTotalAmount + cashPickupPaymentsTotalAmountTmp + cashDineInPaymentsTotalAmountTmp + cashDeliveryPaymentsTotalAmountTmp;
        }
        return cashPaymentsTotalAmount;
      },

      bankAxeptTotalCount() {
        return TurnoverReportUtil.getBankAxeptTotalCount(this.zReports);
      },
      totalBankAxeptPaymentsTotalAmount() {
        var bankAxeptPaymentsTotalAmount = 0;
        for (var i = 0; i < this.zReports.length; i++) {
          var zReport = this.zReports[i].cagistahospitality;
          let bankAxeptPickupPaymentsTotalAmountTmp = zReport.bankAxeptPickupPaymentsTotalAmount ? zReport.bankAxeptPickupPaymentsTotalAmount : 0;
          let bankAxeptDineInPaymentsTotalAmountTmp = zReport.bankAxeptDineInPaymentsTotalAmount ? zReport.bankAxeptDineInPaymentsTotalAmount : 0;
          let bankAxeptDeliveryPaymentsTotalAmountTmp = zReport.bankAxeptDeliveryPaymentsTotalAmount ? zReport.bankAxeptDeliveryPaymentsTotalAmount : 0;
          bankAxeptPaymentsTotalAmount = bankAxeptPaymentsTotalAmount + bankAxeptPickupPaymentsTotalAmountTmp + bankAxeptDineInPaymentsTotalAmountTmp + bankAxeptDeliveryPaymentsTotalAmountTmp;
        }
        return bankAxeptPaymentsTotalAmount;
      },

      loyaltyPointsTotalCount() {
        return TurnoverReportUtil.getLoyaltyPointsTotalCount(this.zReports);
      },
      totalLoyaltyPointsPaymentsTotalAmount() {
        var loyaltyPointsPaymentsTotalAmount = 0;
        for (var i = 0; i < this.zReports.length; i++) {
          var zReport = this.zReports[i].cagistahospitality;
          let amount = zReport.loyaltyPointsPaymentsTotalAmount ? zReport.loyaltyPointsPaymentsTotalAmount : 0;
          loyaltyPointsPaymentsTotalAmount = loyaltyPointsPaymentsTotalAmount + amount;
        }
        return loyaltyPointsPaymentsTotalAmount;
      },

      totalPaymentCount() {
        return (TurnoverReportUtil.getCardTotalCount(this.zReports) + TurnoverReportUtil.getCashTotalCount(this.zReports) + TurnoverReportUtil.getBankAxeptTotalCount(this.zReports) + TurnoverReportUtil.getLoyaltyPointsTotalCount(this.zReports));
      },
      totalPayment() {
        return (this.totalCardPaymentsTotalAmount + this.totalCashPaymentsTotalAmount + this.totalBankAxeptPaymentsTotalAmount + this.totalLoyaltyPointsPaymentsTotalAmount);
      }
    },
    methods: {
      displayTwoDecimals(num){
        if(num > 0 || num < 0){
          return MathUtil.displayTwoDecimals(num);
        }else {
          return num;
        }
      }
    }
  }
</script>
